// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const AiStar = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 16}
    height={size ?? 16}
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.248 10.75a5 5 0 0 0-.095.2q-.405.9-.405 1.8t.405 1.8q.045.1.095.2.05-.1.095-.2.405-.9.405-1.8t-.405-1.8a6 6 0 0 0-.095-.2"
    />
    <path
      fill="currentColor"
      d="M14.255 12.743a5 5 0 0 0-.2-.095q-.9-.405-1.8-.405t-1.8.405q-.1.045-.2.095.1.05.2.095.9.405 1.8.405t1.8-.405q.1-.044.2-.095M12.75 1.25a6 6 0 0 0-.095.2q-.405.9-.405 1.8t.405 1.8q.045.1.095.2.05-.1.095-.2.405-.9.405-1.8t-.405-1.8a5 5 0 0 0-.095-.2"
    />
    <path
      fill="currentColor"
      d="M10.75 3.25q.1.05.2.095.9.405 1.8.405t1.8-.405q.1-.045.2-.095a5 5 0 0 0-.2-.095q-.9-.405-1.8-.405t-1.8.405q-.1.045-.2.095"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M6.342 9.658C5.837 9.472 2.5 8 2.5 8s3.337-1.472 3.842-1.658C6.528 5.837 8 2.5 8 2.5s1.432 3.23 1.658 3.842C10.163 6.528 13.5 8 13.5 8s-3.23 1.432-3.842 1.658C9.472 10.163 8 13.5 8 13.5s-1.472-3.337-1.658-3.842Z"
    />
  </svg>
);
const ForwardRef = forwardRef(AiStar);
export default ForwardRef;
